import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down",
  "use": "icon-down-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"icon-down\"><path fill=\"currentColor\" d=\"M0 0h16v16H0z\" opacity=\".01\" /><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.243 6 8 10.243 3.757 6l.653-.653L8 8.937l3.59-3.59z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol